export default (theme) => ({
    listItem: {
        borderBottom: `1px solid ${theme.palette.border.lightBorder}`,
        padding: theme.spacing(2),
    },
    settingsListContainer: {
        width: "100%",
        padding: 0,
    },
});
